import "./SinglePomdoroPage.css";

const SinglePomdoroPage = () => {
  return <></>;
};

export { SinglePomdoroPage };
